// Parses hub message display text into renderable blocks. The ETL renders Zendesk
// html_body to plain text with '• ' / 'n. ' line markers (two spaces per nesting
// level); recognizing those lines here lets the bubble render real list rows with a
// hanging indent — which pre-wrap plain text cannot do (wrapped lines fall back to
// the left margin). Everything else stays a pre-wrap text block.
export type MessageBlock =
  | { type: 'text'; text: string }
  | { type: 'listItem'; marker: string; text: string; depth: number };

const LIST_LINE_RE = /^(\s*)(•|\d{1,3}\.)\s+(.*)$/;

export function parseMessageBlocks(text: string): MessageBlock[] {
  const blocks: MessageBlock[] = [];
  let textLines: string[] = [];

  const flushText = () => {
    // Trim blank edge lines: spacing between blocks is the renderer's job.
    while (textLines.length && !textLines[0].trim()) textLines.shift();
    while (textLines.length && !textLines[textLines.length - 1].trim()) textLines.pop();
    if (textLines.length) blocks.push({ type: 'text', text: textLines.join('\n') });
    textLines = [];
  };

  String(text ?? '').split('\n').forEach((line) => {
    const m = line.match(LIST_LINE_RE);
    if (m) {
      flushText();
      blocks.push({
        type: 'listItem',
        marker: m[2],
        text: m[3],
        depth: Math.floor(m[1].length / 2),
      });
    } else {
      textLines.push(line);
    }
  });
  flushText();
  return blocks;
}
